import "./MasterTeacher.module.css";
import Header from "@/reusable_sections/Header";
import TheHearthHeritage from "./sections/TheHearthHeritage";
import QualityStandards from "./sections/QualityStandards";
import TheNeighborlyAdvantage from "./sections/TheNeighborlyAdvantage";
import Footer from "@/reusable_sections/Footer";
export default function MasterTeacherPage() {
  return <div>
      <Header />
      <TheHearthHeritage />
      <QualityStandards />
      <TheNeighborlyAdvantage />
      <Footer />
    </div>;
}